/**
 * Cart Count Updater
 * Immediately updates the cart icon count when items are added/removed
 */

class CartCountUpdater {
  constructor() {
    this.cartBubble = document.querySelector('#cart-icon-bubble');
    if (!this.cartBubble) return;

    // Listen for cart update events from Shopify's pub/sub system
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
    }

    // Also listen for custom cart updates (for Buy Now button, etc)
    document.addEventListener('cart:updated', this.updateFromCart.bind(this));
  }

  handleCartUpdate(event) {
    if (!event.cartData) return;

    // Get item count from cart data
    let itemCount = 0;
    if (event.cartData.item_count !== undefined) {
      itemCount = event.cartData.item_count;
    } else if (event.cartData.items) {
      itemCount = event.cartData.items.reduce((total, item) => total + item.quantity, 0);
    }

    this.updateCountBubble(itemCount);
  }

  updateFromCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        this.updateCountBubble(cart.item_count);
      })
      .catch(err => {
        console.error('Failed to fetch cart:', err);
      });
  }

  updateCountBubble(itemCount) {
    if (!this.cartBubble) return;

    let existingCountBubble = this.cartBubble.querySelector('.cart-count-bubble');

    if (itemCount > 0) {
      if (!existingCountBubble) {
        // Create bubble if it doesn't exist
        const bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';

        if (itemCount < 100) {
          const visibleSpan = document.createElement('span');
          visibleSpan.setAttribute('aria-hidden', 'true');
          visibleSpan.textContent = itemCount;
          bubble.appendChild(visibleSpan);
        }

        const hiddenSpan = document.createElement('span');
        hiddenSpan.className = 'visually-hidden';
        hiddenSpan.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
        bubble.appendChild(hiddenSpan);

        this.cartBubble.appendChild(bubble);
      } else {
        // Update existing bubble
        const countSpan = existingCountBubble.querySelector('[aria-hidden="true"]');
        if (countSpan && itemCount < 100) {
          countSpan.textContent = itemCount;
        } else if (!countSpan && itemCount < 100) {
          // Add visible count if it doesn't exist
          const visibleSpan = document.createElement('span');
          visibleSpan.setAttribute('aria-hidden', 'true');
          visibleSpan.textContent = itemCount;
          existingCountBubble.insertBefore(visibleSpan, existingCountBubble.firstChild);
        } else if (countSpan && itemCount >= 100) {
          // Remove visible count if over 100
          countSpan.remove();
        }

        const hiddenSpan = existingCountBubble.querySelector('.visually-hidden');
        if (hiddenSpan) {
          hiddenSpan.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
        }
      }
    } else if (existingCountBubble) {
      // Remove bubble if cart is empty
      existingCountBubble.remove();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CartCountUpdater());
} else {
  new CartCountUpdater();
}
